import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import Logo from "./Logo";

const SIGNIN_URL = process.env.REACT_APP_SIGNIN_URL;

const LINKS = [
  { label: "Video consults", href: "#telehealth" },
  { label: "Platform", href: "#portals" },
  { label: "Features", href: "#features" },
  { label: "Patient journey", href: "#journey" },
  { label: "Security", href: "#security" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const href = (h) => (onHome ? h : `/${h}`);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open ? "border-b border-slate-200/70 bg-white/80 shadow-sm backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between lg:h-[72px]" aria-label="Main">
        <Link to="/" aria-label="Health Frigate home">
          <Logo />
        </Link>

        <ul className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a href={href(l.href)} className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-ink-900">
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-2 lg:flex">
          <a href={SIGNIN_URL} className="rounded-lg px-3 py-2 text-sm font-semibold text-ink-900 hover:bg-slate-100">
            Sign in
          </a>
          <a href={href("#contact")} className="btn-primary !py-2.5">
            Book a demo <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <button
          type="button"
          className="rounded-lg p-2 text-ink-900 hover:bg-slate-100 lg:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-slate-200 bg-white lg:hidden">
          <ul className="container-x flex flex-col py-3">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a href={href(l.href)} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 text-base font-medium text-ink-900 hover:bg-slate-50">
                  {l.label}
                </a>
              </li>
            ))}
            <li className="mt-2 grid grid-cols-2 gap-2">
              <a href={SIGNIN_URL} className="btn-secondary">Sign in</a>
              <a href={href("#contact")} onClick={() => setOpen(false)} className="btn-primary">Book a demo</a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
